/* eslint-disable @nx/enforce-module-boundaries */
import { Box, HStack, Progress, Spinner, Stack, Text } from '@mybridge/ui';
import Link from 'next/link';
import { useContext, useEffect } from 'react';
import { humanFileSize } from 'v4/components/utils';
import { DiskContext } from '../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MyDiskUsageProgress = ({ children }) => {
  const {
    myDiskSubscription,
    refetchMyDiskSubscription,
    myDiskSubscriptionFetching,
    myDiskOccupiedSize,
    refetchMyDiskOccupiedSize,
    myDiskOccupiedSizeFetching,
    initDiskSubscription,
    refetchMyDiskSubscriptionInit,
    myDiskSubscriptionInitLoading,
    myDiskSubscriptionInitFetching,
  } = useContext(DiskContext);

  useEffect(() => {
    refetchMyDiskOccupiedSize?.();
    refetchMyDiskSubscription?.();
  }, []);

  const { t } = useTranslator();

  useEffect(() => {
    if (!myDiskSubscription?.id) {
      initDiskSubscription?.();
    }
  }, [myDiskSubscription?.id]);

  const totalSize_ = (myDiskSubscription?.disk_plan?.storage ?? 0) * 1000000;
  const occupiedSize_ = myDiskOccupiedSize?.occupied_size ?? 0;
  const totalSize = humanFileSize(totalSize_ + '', true, 2);
  const occupiedSize = humanFileSize(
    occupiedSize_ + '' ? myDiskOccupiedSize?.occupied_size + '' : '0',
    true,
    2
  );
  const donePercent = (occupiedSize_ / totalSize_) * 100;
  // console.log('donePercent', donePercent);
  
  const handleUpgradeClick = () => {
    // Set localStorage flag to indicate user came from disk usage progress
    if (typeof window !== 'undefined') {
      localStorage.setItem('redirectAfterDiskSubscription', 'true');
    }
  };

  return (
    <>
      <Stack>
        <HStack>
          <Box flex={1}>
            {myDiskOccupiedSizeFetching || myDiskSubscriptionFetching ? (
              <Spinner size="xs" />
            ) : (<Box justifyContent="space-between" display="flex">

              <Text fontSize={["xs", "sm"]} color="black">
                {occupiedSize == "NaN kB" ? "0" : occupiedSize} {t('myDisk.of') || "of"} {totalSize} {t('myDisk.used') || "used"}
              </Text>
                <HStack fontSize={["xs", "sm"]}>
          <Link href="/settings/subscriptions" onClick={handleUpgradeClick}>{t('myDisk.upgrade') || "Upgrade"}</Link>
        </HStack>
            </Box>
            )}
          </Box>
          {children}
        </HStack>
        <Progress
          borderRadius="full"
          colorScheme={
            donePercent <= 50
              ? 'brandPrimary'
              : donePercent > 50 && donePercent <= 75
              ? 'yellow'
              : 'orange'
          }
          value={donePercent}
          isIndeterminate={
            myDiskOccupiedSizeFetching || myDiskSubscriptionFetching
          }
        />
      </Stack>
    </>
  );
};